module.exports = __webpack_public_path__ + "img/jachetti.3596d0c1.jpg";